<template>
    <div class="app-sidebar">
        <v-card outlined class="border border-transparent">
            <v-list dense flat>
                <v-list-item-title class="subtitle-1 font-weight-bold pa-5">{{$t('categories')}}</v-list-item-title>
                <v-divider></v-divider>
                <div class="overflow-y height-600">
                    <sidebar-skeleton v-if="!subcategoriesList.length && subcategoriesLoading" :items-count="5"></sidebar-skeleton>
                    <subcategories :subcategories="subcategoriesList" v-if="subcategoriesList.length"></subcategories>
                </div>
            </v-list>
        </v-card>
        <general-filters
            :id="currentId"
            :systemName="systemName"
            :total="total"
            filter-key="region"
            ref="generalFilters"
            @update-list="updateList"
        ></general-filters>
    </div>
</template>

<script>
    import CategoryService from '../../../app-front/services/api/CategoryService';
    import GeneralFilters from '../../../app-front/components/filters/GeneralFilters';
    import SidebarSkeleton from '../../../app-front/components/skeletons/BaseSidebarSkeleton';
    import Subcategories from './Subcategories';

    export default {
        name: "RegionSidebar",
        props:['systemName', 'id', 'total'],
        components:{
            GeneralFilters,
            SidebarSkeleton,
            Subcategories
        },
        data() {
            return {
                subcategoriesList: [],
                subcategoriesLoading: true
            }
        },
        computed: {
            currentId() {
                return this.id
            }
        },
        methods: {
            setNavigation() {
                CategoryService.setLocale(this.$store.state.language.appLanguage);

                CategoryService.getRegionWithCount(this.id)
                    .then(res => {
                        this.subcategoriesLoading = false;
                        this.subcategoriesList = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            updateList() {
                this.$emit('update-list');
            },
        },
        watch: {
            currentId() {
                this.setNavigation();
            }
        }

    }
</script>

<style scoped>

</style>
